import React from 'react';
import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { DashboardBackButton } from '@components/utils';
import { SECTION_NAMES } from '@constants/sectionNames';
import { Banner, Button, HeadContent, Icon, Loading } from '@fourthwall/components';
import { NewWindowIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
import { AppsZapierSkeleton } from './AppsZapierSkeleton';
import ZapierConnectScreen from './assets/zapier_connect.png';
import { useZapier } from './hooks/useZapier';
export const AppsZapier = () => {
    const { connectBar, isLoading, status } = useZapier();
    if (!connectBar) {
        return React.createElement(AppsZapierSkeleton, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Zapier" }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: "Zapier", topContent: React.createElement(DashboardBackButton, { label: SECTION_NAMES.apps, to: routing.apps.self }), bottomContent: React.createElement("p", null,
                    "Connect your Fourthwall account to thousands of apps and automate your workflows.",
                    ' ') },
                React.createElement(Loading, { isLoading: isLoading },
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } },
                        React.createElement(ConnectBar, { ...connectBar }),
                        status === 'NOT_CONNECTED' ? (React.createElement(Banner, { appearance: "info", title: React.createElement("b", null, "How to connect") },
                            React.createElement("div", { style: { width: 300, height: 400, overflow: 'hidden' } },
                                React.createElement("img", { src: ZapierConnectScreen, style: {
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    } })),
                            React.createElement("p", null, "From a Zapier zap, simply click the Account selector and create a new connection."))) : (React.createElement("div", { style: { padding: 16 } },
                            React.createElement("p", null,
                                React.createElement(Button, { appearance: "primary", label: "Build your zap on Zapier", icon: React.createElement(Icon, { component: NewWindowIcon, height: 16, width: 16 }), href: routing.external.zapier.createZap, target: "_blank" }))))))))));
};
